function getApiBaseUrl(): string {
  const env = (window as { _env_?: Record<string, string> })._env_;
  const base =
    env?.REACT_APP_API_FORM_FLOW ||
    (process.env.REACT_APP_API_FORM_FLOW
      ? atob(process.env.REACT_APP_API_FORM_FLOW)
      : '') ||
    '';
  return base.replace(/\/api\/?$/, '');
}

export function normalizeMediaUrl(url: string | null | undefined): string | null {
  if (!url) {
    return null;
  }

  const trimmed = url.trim();
  if (!trimmed) {
    return null;
  }

  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    return trimmed;
  }

  const apiBase = getApiBaseUrl();
  if (!apiBase) {
    return trimmed;
  }

  if (trimmed.startsWith('/')) {
    return `${apiBase}${trimmed}`;
  }

  return `${apiBase}/${trimmed}`;
}
